import { SerializableObject } from '../../common-react/core';

import { BoxAvailability } from '../other/box-availability';

// DTO Object for representing generic Addresses
export class PostalDropOption extends SerializableObject {
  // Delivery location Id
  public deliveryLocationId: string;

  // Shipment Id
  public shipmentId: string;

  // Sender postal code
  public senderPostalCode: string;

  // Boxes available
  public boxAvailability: BoxAvailability;
}

/**
 * Use this postal code as default for the PosturinnServerApi.PostalDropOption requests.
 */
export const DEFAULT_SENDER_POSTAL_CODE: string = '101';
